import { useState } from "react";

type CameraCounts = {
  high: number;
  medium: number;
  low: number;
};

const INITIAL_PLAY_SPEED = 1;
const HOUR = 1000 * 3600;
const HOUR_AGO = new Date(+new Date() - HOUR);
const INITIAL_COUNTS: CameraCounts = { high: 0, medium: 0, low: 0 };

export type CameraOptionsHook = ReturnType<typeof useCameraOptions>;
/**
 * Gets or sets the current filters and options for camera view
 */
export function useCameraOptions() {
  const [live, setLive] = useState<boolean>(true);
  const [heatmapsOn, setHeatmapsOn] = useState<boolean>(false);
  const [listViewOn, setListViewOn] = useState<boolean>(false);
  const [speed, setSpeed] = useState<number>(INITIAL_PLAY_SPEED);
  const [startTime, setStartTime] = useState<Date>(new Date());
  const [counts, setCounts] = useState<CameraCounts>(INITIAL_COUNTS);
  const [siteFilter, setSiteFilter] = useState<string>("");
  const [riskFilter, setRiskFilter] = useState<number>(0);

  const options = {
    live,
    heatmapsOn,
    listViewOn,
    speed,
    startTime,
    counts,
    siteFilter,
    riskFilter,
  };
  const setters = {
    setLive,
    setHeatmapsOn,
    setListViewOn,
    setSpeed,
    setStartTime,
    setCounts,
    setSiteFilter,
    setRiskFilter,
  };

  return { options, setters };
}
